import { AMENITIES } from './constants';

const StepAmenities = ({ formData, toggleAmenity }) => {
  return (
    <div className="space-y-6">
      <p className="text-sm text-gray-600 mb-4">
        Select all amenities that apply to your listing
      </p>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {AMENITIES.map((amenity) => {
          const AmenityIcon = amenity.icon;
          const isSelected = formData.amenities.includes(amenity.id);
          return (
            <button
              key={amenity.id}
              type="button"
              onClick={() => toggleAmenity(amenity.id)}
              className={`p-4 rounded-lg border-2 transition-all text-left ${
                isSelected
                  ? 'border-emerald-500 bg-emerald-50'
                  : 'border-gray-200 hover:border-emerald-300 hover:bg-emerald-50/30'
              }`}
            >
              <div className="flex items-center gap-3">
                <div
                  className={`p-2 rounded-lg ${
                    isSelected ? 'bg-emerald-600 text-white' : 'bg-gray-100 text-gray-600'
                  }`}
                >
                  <AmenityIcon className="w-5 h-5" />
                </div>
                <span className={`text-sm font-medium ${isSelected ? 'text-emerald-900' : 'text-gray-700'}`}>
                  {amenity.label}
                </span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default StepAmenities;

